/* eslint-disable no-return-assign */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Pagination from 'modules/common/components/Pagination';
import * as actions from '../actions';
import * as c from '../constant';

function TransmittalListModal({
  type,
  getTransmittalList,
  transmittalList,
  pager,
  isLoading,
}) {
  useEffect(() => {
    const args = {
      type,
    };
    getTransmittalList(args);
  }, []);

  const handleChangePage = page => {
    const args = {
      type,
      page,
    };
    getTransmittalList(args);
  };

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              {isLoading ? (
                <div
                  className="loading d-flex text-center justify-content-center align-items-center"
                  style={{ height: '500px' }}
                >
                  <div className="spinner text-center ">
                    <span className="fas fa-5x fa-spin fa-spinner" />
                  </div>
                </div>
              ) : (
                <table className="table table-striped table-sm table-bordered table-hover">
                  <thead className="table-header">
                    <tr>
                      <th>TRANSMITTAL NUMBER</th>
                      <th>APPLICATIONS</th>
                      <th>TYPE</th>
                      <th>YEAR</th>
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {transmittalList.map(item => {
                      return (
                        <tr key={item.id}>
                          <td>
                            {_.get(item, 'attributes.transmittal_no') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.applications') || '---'}
                          </td>
                          <td>{_.get(item, 'attributes.type') || '---'}</td>
                          <td>{_.get(item, 'attributes.year') || '---'}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              <div className="list-pagination">
                {pager.total_pages > 1 ? (
                  <div className="d-flex justify-content-center text-center align-item-center">
                    <Pagination data={pager} onChange={handleChangePage} />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

TransmittalListModal.defaultProps = {
  type: '',
};

TransmittalListModal.propTypes = {
  type: PropTypes.string,
  getTransmittalList: PropTypes.instanceOf(Function).isRequired,
  transmittalList: PropTypes.instanceOf(Object).isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  transmittalList: _.get(api, `${c.GET_TRANSMITTAL_LIST}.list`) || [],
  pager: _.get(api, `${c.GET_TRANSMITTAL_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_TRANSMITTAL_LIST) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TransmittalListModal);
